import { MessageApi } from '@linktivity/triplabo-taxi';

import config from '../config';

const message = new MessageApi(config);

export default message;
